<template>
  <div class="release-notes">
    <MainBackButton :forceHome="true" />
    <p class="header">
      Release Notes
      <span class="is-pulled-right has-text-weight-medium">
        {{ updatedAt }}
      </span>
    </p>
    <div class="content-wrapper">
      <div class="content no-scrollbar" v-html="html" />
    </div>
  </div>
</template>

<script>
import MainBackButton from "@/components/MainBackButton.vue";
import marked from "marked";

export default {
  name: "ReleaseNotes",
  components: {
    MainBackButton,
  },
  data() {
    return {
      updatedAt: "21 June @ 13:00",

      // \`\`\`
      // 🤹🏼‍♂️ Let's go go go!!!
      // \`\`\`

      ///////////////////////////// PUT MARKDOWN IN CONTENT /////////////////////////////
      content: `

#### Release Notes
You're reading it. I'll put stuff here going forward.

#### [Driver Wallet](../driver)
I prompt drivers to add their PromptPay and Bank Account details now. This is needed to allow customers to pay via Contactless Payment methods.

#### [User Profile](../profile)
- Notification preferences: SMS, Email, Push
- User can also enter their email on this page
- Force SMS OFF - for superusers to save 💰

#### [Orders](../orders)
- Changed to use business profile  pics
- Tweaked buttons below
- Lucky draw / referral callout

#### Contactless Payments
- Customer will see it on the \`commerce_order\` page
- If driver has it set up they will see the details
- They can pay and upload the payment receipt
- Payment receipt will show to driver as \`PAID\`

#### TUK Express
- \`tuk_express\` settings in commerce json
- Send vs Receive modes

#### Pre-order
- Special \`time\` and \`date\` options menus
- Set it up in [advanced menu editor](../menu_editor)

#### Reverse Delivery Mode
- For any commerce that needs to deliver the other way e.g. for laundry
- In commerce json: \`"delivery_options":{"reversed":true}\`

#### Delivery Promo Code
- \`FREE4\` try it and see
- *Free delivery up to 4km with 400 baht minimum order*
- Could be used in tandem with Referral campaign

#### Referral Codes
- 6 character unique codes for each user, e.g. TKLQSB

#### [Instagram Mode](../@burritosquad?insta=true)
- add URL param \`instagram=true\` or \`insta=true\` 
- e.g. *e.tukapp.co/@whynot?insta=true*
- this link works anywhere, but particularly well on instagram
- shops should upload higher quality images with a width of up to 450px otherwise it could look grainy

---

![THE END](https://cdn.dribbble.com/users/19781/screenshots/656766/thatsallfolkx.png)
`,
      /////////////////////////////// END MARKDOWN ///////////////////////////////
    };
  },
  computed: {
    html() {
      return marked(this.content, { sanitize: true });
    },
  },
  methods: {},
};
</script>

<style scoped>
.release-notes {
  text-align: left;
  background-color: slategrey;
  color: white;
  height: 100vh;
}
.header {
  padding: 15px;
  margin-left: 44px;
  font-size: 1.1em;
}
.content-wrapper {
  width: 100vw;
  padding: 0 12px;
  background-color: #333;
}
.content {
  padding-top: 16px;
  padding-bottom: 20px;
  /* width: calc(100% - 12px); */
  height: calc(100vh - 56px);
  overflow: auto;
  /* color: #eee; */
}
.content >>> h2 {
  color: white;
}
.content >>> :is(h1, h2, h5, h6) {
  color: lightgoldenrodyellow;
}
.content >>> :is(h3, h4) {
  color: lightskyblue;
}
.content >>> a {
  color: lightskyblue;
  border-bottom: 1px dotted lightblue;
}
.content >>> code {
  background-color: black;
  color: rgba(255, 166, 0, 0.9);
  border-radius: 2px;
}
</style>